<template>
	<div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Paket Saya</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Paket Saya</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">

					<div class="row">
						
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<Sidebar />
						</div>
						<!-- / Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">
							<div class="custom-container"  style="margin-bottom:20px">
								<div class="row align-items-center">
									
									<template v-if="lstpaket">
									<div class="col-paket"  v-for="(ref) in lstpaket" :key="ref.id_paket">
										<a class="products-list__item" > 
											<!-- @click.prevent="getDetail(ref)" -->
											<div class="product-card product-promo-card"> 
												<input clas="post" id="id_produk" name="id_produk" type="hidden" value="270"> 
												<div class="product-card__badges-list"> 
													<!-- <div class="product-card__badge product-card__badge--sale bg-slot"  v-if="ref.fg_pendaftaran == '2'">{{ref.slot}} Slot</div>  -->
												</div> 
												<div class="product-card__image">
													<a> 
														<img :src="ref.url_gambar" alt="">
													</a> 
												</div> 
												<div class="product-card__info"> 
													<div class="product-card__name">
														<a>{{ref.nama_paket}}</a>
													</div> 
													<!-- <div class="bg-warning px-2 pt-1 pb-0.5 tersedia">
														<p>Tersedia {{ref.slot}} Slot</p>
													</div> -->
													<div class="flex items-center mt-1">
														<div class="sm:flex items-center">
															<h4 class="font-medium text-xs sm:text-sm text-red-600 mr-1">
																<del>Rp{{ref.harga_awal}}</del>
															</h4> 
															<h3 class="font-semibold text-base text-gray-900">Rp{{ref.harga_aktif}}</h3>
														</div>
													</div>
												</div> 
												 
												<div class="product-card__info text-center">
													<btn class="btn btn-fill-blue btn-sm text-xs" @click.prevent="getDetail(ref)" >
														Mulai Belajar
													</btn>
												</div>
											</div> 
										</a>


									</div>
									</template>
									<template v-else>
										<div class="col-12 text-center" >
											<div class="img-part">
												<img src="https://img.icons8.com/arcade/64/000000/experimental-error-arcade.png">
											</div>  <br> 
											<h5 class="text-info">Maaf, Paket tidak ditemukan</h5>
										</div>
									</template>

								</div>
							</div>							
						</div>
					</div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		</div>
			
		<div id="addMdl" class="modal custom-modal fade" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Tambah Paket</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">

						<!-- <div class="card card-table mb-0">
							<div class="card-body"> -->
								<!-- Tab Menu -->
								<nav class="user-tabs mb-4">
									<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
										<li class="nav-item">
											<a class="nav-link active" href="#informasipaket" data-toggle="tab"><span class="med-records">Info Paket</span></a>
										</li>
										<li class="nav-item" v-if="paket.id_paket">
											<a class="nav-link" href="#attachtryout" data-toggle="tab">Attach Tryout</a>
										</li> 
										<li class="nav-item" v-if="paket.id_paket">
											<a class="nav-link" href="#attachkategori" data-toggle="tab">Attach Kategori</a>
										</li>
									</ul>
								</nav>
								<!-- /Tab Menu -->
								
								<!-- Tab Content -->
								<div class="tab-content pt-0">
											
									<!-- Course Records Tab -->
									<div id="informasipaket" class="tab-pane fade show active">
										<!-- <div class="card card-table">											 -->
											<!-- <div class="card-body">
												<div class="table-responsive"> -->
													<form id="frm">                            
														<div class="row">
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Nama Paket</label>
																	<input class="form-control" type="text" v-model="paket.nama_paket">
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Tipe</label>
																	<v-select
																	:options="lsttipe"
																	:reduce="lsttipe => lsttipe.id" 
																	label="text"
																	v-model="paket.tipe_paket"
																	/>	
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Harga Awal</label>
																	<input class="form-control" type="text" v-model="paket.harga_awal">
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Diskon Harga</label>
																	<input class="form-control" type="text" v-model="paket.diskon">
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Masa Berlaku (bulan)</label>
																	<input class="form-control" type="text" v-model="paket.masa_berlaku">
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Diskon Referral</label>                                      
																	<input class="form-control" type="text" v-model="paket.diskon_referral">
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Komisi Referral</label>
																	<input class="form-control" type="text" v-model="paket.komisi_referral">
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>URL Gambar</label>
																	<input class="form-control" type="text" v-model="paket.url_gambar">
																</div>
															</div>
															
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status</label>
																	<v-select
																	:options="lststspublish"
																	:reduce="lststspublish => lststspublish.id" 
																	label="text"
																	v-model="paket.fg_publish"
																	/>
																	
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status Pendaftaran</label>
																	<v-select
																	:options="lststspendaftaran"
																	:reduce="lststspendaftaran => lststspendaftaran.id" 
																	label="text"
																	v-model="paket.fg_pendaftaran"
																	/>
																	
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status Favorit</label>
																	<v-select
																	:options="lststsfav"
																	:reduce="lststsfav => lststsfav.id" 
																	label="text"
																	v-model="paket.fg_favorit"
																	/>
																	
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Link Telegram</label>
																	<input class="form-control" type="text" v-model="paket.url_telegram">
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12" v-if="paket.fg_slot == '2'">
																<div class="form-group card-label">
																	<label>Kuota</label>
																	<input class="form-control" type="text" v-model="paket.slot">
																</div>
															</div>
															
															<div class="col-md-12 col-sm-12">
																<hr>
																<div class="table-responsive">		
																		
																	<h3>BENEFIT PAKET</h3>																
																	<div class="col-auto text-right float-right ml-auto">
																		<a href="#" class="btn btn-primary btn-sm" @click.prevent="addBenefit()">Tambah Benefit</a>
																	</div>
																	<table id="tbl" class="table table-hover table-center mb-0">
																		<thead>
																			<tr>
																				<th>No</th>
																				<th>Benefit</th>
																				<th>Aksi</th>
																			</tr>     
																		</thead>
																		<tbody>
																			<tr v-for="(ref, index) in lstbenefit" :key="ref">
																				<td class="text-center">{{ index + 1 }}</td>
																				<td><input class="form-control" type="text" v-model="ref.nama_benefit"></td>										
																				<td class="text-center">
																					<v-btn color="btn btn-sm bg-danger-light" depressed small @click="deleteBenefit(index)">
																						<i class="fas fa-times"></i> Delete
																					</v-btn>
																				</td>
																			</tr>
																			
																		</tbody>  	
																	</table>																	
																</div>
															</div>
															
															<div v-if="paket.tipe_paket=='2'" class="col-md-12 col-sm-12">
																<hr>
																<div class="table-responsive">	
																	<h3>JADWAL BIMBEL</h3>																
																	<div class="col-auto text-right float-right ml-auto">
																		<a href="#" class="btn btn-primary btn-sm" @click.prevent="addJadwal()">Tambah Jadwal</a>
																	</div>
																	<table id="tbl" class="table table-hover table-center mb-0">
																		<thead>
																			<tr>
																				<th>Pertemua Ke</th>
																				<th>Judul</th>
																				<th>Jadwal</th>
																				<th>Aksi</th>
																			</tr>     
																		</thead>
																		<tbody>
																			<tr v-for="(ref, index) in lstjadwal" :key="ref">
																				<td class="text-center">{{ index + 1 }}</td>
																				<td><input class="form-control" type="text" v-model="ref.judul_pertemuan"></td>										
																				<td><input class="form-control" type="datetime-local"  v-model="ref.jadwal_pertemuan"></td>										
																				<td class="text-center">
																					<v-btn color="btn btn-sm bg-danger-light" depressed small @click="deleteJadwal(index)">
																						<i class="fas fa-times"></i> Delete
																					</v-btn>
																				</td>
																			</tr>
																			
																		</tbody>  	
																	</table>																	
																</div>
															</div>
															
														</div>
														
														<!-- <div class="form-group">
															<label>Judul <span class="text-danger">*</span></label>
															<input class="form-control" type="text" v-model="subdtlmateri.nama_judul">
														</div> -->
														<br>
													</form>
												<!-- </div>
											</div> -->
										<!-- </div> -->
									</div>

									
									<div id="attachtryout" class="tab-pane fade">
										<div class="table-responsive">
											
											<h3>Daftar Latihan</h3>		
											<table id="tblToPaket" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan / Kategori / Subject</th>
														<th class="text-left">Paket Soal</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in paketlsttryout" :key="ref.id_to">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }} / {{ ref.nama_materi }} / {{ ref.nama_sub_materi }}</td>
														<td>{{ ref.nama_to }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="deattachTo(index, ref)">
																<i class="fas fa-eye"></i> DeAttach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
											<br><hr><br>
											
											<h3>Draft Latihan</h3>		
											<table id="tblToDraft" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan / Kategori / Subject</th>
														<th class="text-left">Paket Soal</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in lsttryout" :key="ref.id_to">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }} / {{ ref.nama_materi }} / {{ ref.nama_sub_materi }}</td>
														<td>{{ ref.nama_to }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="attachTo(index, ref)">
																<i class="fas fa-eye"></i> Attach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
										</div>
									</div>

									<div id="attachkategori" class="tab-pane fade">
										<div class="table-responsive">
											
											<h3>Daftar Kategori</h3>		
											<table id="tblKategoriPaket" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan</th>
														<th class="text-left">Materi</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in paketlstmateri" :key="ref.id_materi">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }}</td>
														<td>{{ ref.nama_materi }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="deattachKategori(index, ref)">
																<i class="fas fa-eye"></i> DeAttach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
											<br><hr><br>
											
											<h3>Draft Kategori</h3>		
											<table id="tblKategoriDraft" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan</th>
														<th class="text-left">Materi</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in lstmateri" :key="ref.id_materi">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }}</td>
														<td>{{ ref.nama_materi }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="attachKategori(index, ref)">
																<i class="fas fa-eye"></i> Attach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
										</div>
									</div>

								</div>	
							<!-- </div>
						</div> -->

					</div>
					<div class="modal-footer">
						<div class="submit-section text-center">
							<button class="btn btn-primary submit-btn" @click.prevent="save">Simpan Paket</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		
        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Paket</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus paket <b>{{ paket.nama_paket }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>


	</div>
		<!-- /Main Wrapper -->
</template>


<script>
// import instructors from '../../../assets/json/instructorslist'
// const images = require.context('@/assets/img/clients', false, /\.png$|\.jpg$/)
// import schoolvisits from '../../../assets/json/instructor/dashboard/schoolvisits'
// import coursetakenrecords from '../../../assets/json/instructor/dashboard/coursetakenrecords'
// import billing from '../../../assets/json/instructor/dashboard/billing'

import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

export default {
    components: {
        Sidebar
    },
	name: 'paket-saya',
    // vuetify: new Vuetify(),
    data() {
        return {
            lstpaket: [],
            paket:{
                id_paket: '',
                nama_paket: '',
                tipe_paket: '',
                harga_awal: '',
                diskon: '',
				harga_aktif: '',
                masa_berlaku: '',
				jml_to: '',
                diskon_referral: '',
                komisi_referral: '',
                url_gambar: '',
                fg_publish: '',
                fg_pendaftaran: '',
                fg_favorit: '',
                url_telegram: '',
                slot: '',
            },
            lsttipe: [
                {id: '1', text: 'MANDIRI'},
                {id: '2', text: 'BIMBEL'}
            ],
            lststspublish: [
                {id: '1', text: 'DRAFT'},
                {id: '2', text: 'PUBLISH'}
            ],
            lststspendaftaran: [
                {id: '1', text: 'DITUTUP'},
                {id: '2', text: 'DIBUKA'}
            ],
            lststsfav: [
                {id: '1', text: 'TIDAK'},
                {id: '2', text: 'YA'}
            ],
			lstbenefit: [],
			lstjadwal: [],
			lsttryout: [],
			paketlsttryout: [],
			lstmateri: [],
			paketlstmateri: [],
            //     {id_paket_benefit: '1', nama_benefit: 'Benefit 1'},
			// ]
            // lstmateri: [],
            // materi:{
            //     id_materi: '',
            //     id_tingkatan: '',
            //     nama_materi: '',
            // },
            // lstsubmateri: [],
            // submateri: {
            //     id_sub_materi: '',
            //     id_materi: '',
            //     nama_sub_materi: '',
            // },
        }
    },
    created: function () {
        // this.refreshAll();
        
        this.getAll();
        // this.getAllMateri();
        // this.getAllSub();
        // this.initDt("tblMateri");
        // this.initDt("tblSub");

    },  

    methods: {
        
        // Get Product
        getAll: function () {
            axios.get('api/paketsaya/'+localStorage.getItem('idUser'))
                .then(res => {
                    // console.log(res.data);
                    // this.clearTbl("tbl");
                    this.lstpaket = res.data.data;
					// console.log(res.data.data);
                    // this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        getDetail: function (ref) {
            
            localStorage.setItem("idPaket", ref.id_paket);  //idPaket: ref.id_paket,  
            this.$router.push({name:'siswa-paket-saya-detail'});                
            // this.$router.push({name:'siswa-paket-saya-detail', params: {idUser: localStorage.getItem('idUser'), idPaketSales: ref.id_sales}}); 
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Siswa/PaketSaya/index.vue